/** @jsx jsx */
import { forwardRef, memo } from 'react';
import { css, jsx } from '@emotion/react';
var flexAlignItemsMap = {
  center: css({
    alignItems: 'center'
  }),
  baseline: css({
    alignItems: 'baseline'
  }),
  flexStart: css({
    alignItems: 'flex-start'
  }),
  flexEnd: css({
    alignItems: 'flex-end'
  }),
  start: css({
    alignItems: 'start'
  }),
  end: css({
    alignItems: 'end'
  })
};
var flexJustifyContentMap = {
  center: css({
    justifyContent: 'center'
  }),
  flexStart: css({
    justifyContent: 'flex-start'
  }),
  flexEnd: css({
    justifyContent: 'flex-end'
  }),
  start: css({
    justifyContent: 'start'
  }),
  end: css({
    justifyContent: 'end'
  })
};
var flexWrapMap = {
  wrap: css({
    flexWrap: 'wrap'
  })
};
var baseStyles = css({
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column'
});

/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the vertical layout of direct children.
 * Renders a `div` by default.
 *
 * @private
 * @deprecated DSP-8009: This primitive is scheduled for deletion.
 * Please use `Stack` from `@atlaskit/primitives` instead.
 *
 */
var Stack = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var gap = _ref.gap,
    alignItems = _ref.alignItems,
    justifyContent = _ref.justifyContent,
    flexWrap = _ref.flexWrap,
    children = _ref.children,
    UNSAFE_style = _ref.UNSAFE_style,
    testId = _ref.testId;
  return jsx("div", {
    style: UNSAFE_style,
    css: [baseStyles, gap && rowGapMap[gap], alignItems && flexAlignItemsMap[alignItems], justifyContent && flexJustifyContentMap[justifyContent], flexWrap && flexWrapMap[flexWrap]],
    "data-testid": testId,
    ref: ref
  }, children);
}));
Stack.displayName = 'Stack';
export default Stack;

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b762b9e20e785c1909a1c59c2791a66e>>
 * @codegenId spacing
 * @codegenCommand yarn codegen-styles
 * @codegenParams ["rowGap"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::167d3b69b159ae33e74d4ea5ab7eade6>>
 */
var rowGapMap = {
  'space.0': css({
    rowGap: "var(--ds-space-0, 0px)"
  }),
  'space.025': css({
    rowGap: "var(--ds-space-025, 2px)"
  }),
  'space.050': css({
    rowGap: "var(--ds-space-050, 4px)"
  }),
  'space.075': css({
    rowGap: "var(--ds-space-075, 6px)"
  }),
  'space.100': css({
    rowGap: "var(--ds-space-100, 8px)"
  }),
  'space.1000': css({
    rowGap: "var(--ds-space-1000, 80px)"
  }),
  'space.150': css({
    rowGap: "var(--ds-space-150, 12px)"
  }),
  'space.200': css({
    rowGap: "var(--ds-space-200, 16px)"
  }),
  'space.250': css({
    rowGap: "var(--ds-space-250, 20px)"
  }),
  'space.300': css({
    rowGap: "var(--ds-space-300, 24px)"
  }),
  'space.400': css({
    rowGap: "var(--ds-space-400, 32px)"
  }),
  'space.500': css({
    rowGap: "var(--ds-space-500, 40px)"
  }),
  'space.600': css({
    rowGap: "var(--ds-space-600, 48px)"
  }),
  'space.800': css({
    rowGap: "var(--ds-space-800, 64px)"
  })
};

/**
 * @codegenEnd
 */